import { defineMessages } from 'react-intl';
const messages = defineMessages({
    LegalEntities: {
        id: 'LegalEntities',
        defaultMessage: 'Legal entities',
    },
    Identification: {
        id: 'Identification',
        defaultMessage: 'Identification',
    },
    Name: {
        id: 'Name',
        defaultMessage: 'Name',
    },
    Address: {
        id: 'Address',
        defaultMessage: 'Address',
    },
    msgNameRequired: {
        id: 'msgNameRequired',
        defaultMessage: 'Name is required',
    },
    msgAddressIncomplete: {
        id: 'msgAddressIncomplete',
        defaultMessage: 'The address is incomplete',
    },
    msgChangesSavedForName: {
        id: 'msgChangesSavedForName',
        defaultMessage: 'Changes saved for {name}',
    },
    msgNoLegalEntities: {
        id: 'msgNoLegalEntities',
        defaultMessage: 'No legal entities yet. Click "Add legal entity" to create one.',
    },
    Delete: { id: 'Delete', defaultMessage: 'Delete' },
    msgConfirmDeleteLegalEntityTitle: {
        id: 'msgConfirmDeleteLegalEntityTitle',
        defaultMessage: 'Delete legal entity?',
    },
    msgConfirmDeleteLegalEntity: {
        id: 'msgConfirmDeleteLegalEntity',
        defaultMessage: 'Are you sure you want to delete the legal entity "{name}"?',
    },
    msgLegalEntityDeleted: {
        id: 'msgLegalEntityDeleted',
        defaultMessage: 'Legal entity "{name}" has been deleted',
    },
});
export default messages;
